import { api, fetchWithCSRF } from '../utils/apiUtils';
import { config } from '../config';

const API_URL = config.API_URI;

/**
 * Fetch all available templates (system + user's own)
 */
export const fetchTemplates = async (workspaceId) => {
  try {
    const params = workspaceId ? `?workspaceId=${workspaceId}` : '';
    const response = await api.get(`${API_URL}/v1/templates${params}`);
    return response;
  } catch (error) {
    console.error('Error fetching templates:', error);
    throw error;
  }
};

/**
 * Create a new template
 */
export const createTemplate = async (templateData) => {
  try {
    const response = await fetchWithCSRF(`${API_URL}/v1/templates`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(templateData),
    });
    return await response.json();
  } catch (error) {
    console.error('Error creating template:', error);
    throw error;
  }
};

/**
 * Delete a template
 */
export const deleteTemplate = async (templateId) => {
  try {
    const response = await fetchWithCSRF(`${API_URL}/v1/templates/${templateId}`, {
      method: 'DELETE',
    });
    return await response.json();
  } catch (error) {
    console.error('Error deleting template:', error);
    throw error;
  }
};

/**
 * Create a page from a template
 */
export const createPageFromTemplate = async (templateId, { workspaceId, parentId } = {}) => {
  try {
    const response = await fetchWithCSRF(`${API_URL}/v1/templates/${templateId}/use`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ workspaceId, parentId }),
    });
    return await response.json();
  } catch (error) {
    console.error('Error creating page from template:', error);
    throw error;
  }
};

/**
 * Save a page as a template
 */
export const savePageAsTemplate = async ({ pageId, name, description, category }) => {
  try {
    const response = await fetchWithCSRF(`${API_URL}/v1/templates/save-from-page`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pageId, name, description, category }),
    });
    return await response.json();
  } catch (error) {
    console.error('Error saving page as template:', error);
    throw error;
  }
};
